import React from 'react';
import { t } from 'Src/i18n';
import { UnmountClosed } from 'react-collapse';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { AdditionalTransportFilterButton } from './AdditionalTransportFilterButton';
type BaseAdditionalTransportFilterProps = {
  type: 'stopovers' | 'companies' | 'connectingCities';
  updateFilters: (key: TransportFiltersKeys, value: string | TransportDateRange) => void;
  withLength?: boolean;
};
const filterType = {
  stopovers: 'stop_number',
  companies: 'flight_company',
  connectingCities: 'connecting_flight_city',
};
type AdditionalTransportFilterWithButtonsProps = {
  filters: Array<TransportFilter>;
} & BaseAdditionalTransportFilterProps;
type FilterWithButtonsProps = {
  filter: TransportFilter;
} & BaseAdditionalTransportFilterProps;

const getStopoverLabel = (stopovers: string) => {
  switch (stopovers) {
    case '0':
      return t('filters.layovers.direct');

    case '1':
      return `${stopovers} ${t('filters.layovers.stop.label_1')}`;

    default:
      return `${stopovers} ${t('filters.layovers.stop.label_n')}`;
  }
};

const FilterWithButtons = ({ type, filter, withLength, updateFilters }: FilterWithButtonsProps) => {
  const label = type === 'stopovers' ? getStopoverLabel(filter.value) : filter.label;
  const { trackClickEvent } = useTrackEvent();
  return (
    <div className="mb-10">
      <AdditionalTransportFilterButton
        label={`${label} ${withLength ? `(${filter.flightIdList.length})` : ''}`}
        isSelected={filter.isSelected}
        onClick={() => {
          trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
            detail_click: `filter_${filterType[type]}`,
          });
          updateFilters(type, filter.value);
        }}
      />
    </div>
  );
};

export const AdditionalTransportFilterWithButtons = ({
  type,
  updateFilters,
  filters,
  withLength,
}: AdditionalTransportFilterWithButtonsProps) => {
  const [toggleMoreFilters, setToggleMoreFilters] = React.useState(false);
  return (
    <div data-testid="AdditionalTransportFilterWithButtons" className="block">
      <div className="block">
        {filters.slice(0, 3).map((filter) => (
          <FilterWithButtons
            type={type}
            key={`filter-${filter.value}`}
            filter={filter}
            withLength={withLength}
            updateFilters={updateFilters}
          />
        ))}
        <UnmountClosed isOpened={toggleMoreFilters}>
          {filters.slice(3).map((filter) => (
            <FilterWithButtons
              type={type}
              key={`filter-${filter.value}`}
              filter={filter}
              withLength={withLength}
              updateFilters={updateFilters}
            />
          ))}
        </UnmountClosed>
      </div>
      {filters.length > 3 && (
        <button
          type="button"
          onClick={() => setToggleMoreFilters(!toggleMoreFilters)}
          className="cursor-pointer text-16 font-semibold underline"
        >
          {toggleMoreFilters ? t('common.loadLess') : t('common.loadMore')}
        </button>
      )}
    </div>
  );
};
